import moment from "moment";

export default function isAuctionLive(sale) {
    const endDate = moment(sale?.startDate).add(Math.floor(sale?.duration / 86400), 'days')
    const now = moment();
    return sale?.type === 'fixed-price' ? sale?.status === 'live' : sale?.status === 'live' && now.isBefore(endDate);
}